// import ScrollReveal from 'scrollreveal';
// import {TweenMax, Power2, TimelineLite, TimelineMax} from "gsap/TweenMax";
import Swiper from 'swiper';
import "./mobile-detect";

var stellar = require("stellar.js");

window.$ = require('jquery');

$(document).ready(function(){
  // active urls
  var url = window.location.pathname;
  var urlsplit = url.split("/").slice(-1)[0];
  console.log(urlsplit);
  $('.main-nav a[href*="'+urlsplit+'"]').parent().addClass("active-nav").siblings().removeClass("active-nav");
  $('.main-nav a[href*="'+urlsplit+'"]').parents(".mn-sub").parent().addClass("active-nav").siblings().removeClass("active-nav");


    function footerFixed(){
      if($(window).width() > 1199){
        $(".wrapper").css("margin-bottom", $(".footer-main").outerHeight());
      }else{
        $(".wrapper").css("margin-bottom", 0);
      }
    }
    footerFixed();
    $(window).resize(function(){
      footerFixed();
    });

var cl = $(".header-bottom").clone(true, true).addClass("fixed-header");

$("body").append(cl);

var lastScrollTop = 0;
$(window).scroll(function(event) {
  var st = $(this).scrollTop();
  var topOffset = $(".header-main").height();
  if (st > lastScrollTop && st < topOffset) {
    // downscroll code
    $(".fixed-header").removeClass("sticky-header");
  } else if (st < lastScrollTop && st > topOffset) {
    // upscroll code
    $(".fixed-header").addClass("sticky-header");
  }else {
    $(".fixed-header").removeClass("sticky-header");
  }
  lastScrollTop = st;
});



  function parallaxIt() {
    // create variables
    var $fwindow = $(window);
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    var $contents = [];
    var $backgrounds = [];

    // for each of content parallax element
    $('[data-type="content"]').each(function(index, e) {
      var $contentObj = $(this);

      $contentObj.__speed = ($contentObj.data('speed') || 1);
      $contentObj.__fgOffset = (0);
      $contents.push($contentObj);
    });

    // for each of background parallax element
    $('[data-type="background"]').each(function() {
      var $backgroundObj = $(this);

      $backgroundObj.__speed = ($backgroundObj.data('speed') || 1);
      $backgroundObj.__fgOffset = ($backgroundObj.data('offset') || $backgroundObj.offset().top);
      $backgrounds.push($backgroundObj);
    });


    // update positions
    $fwindow.on('scroll resize', function(e) {
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      $contents.forEach(function($contentObj) {
        var yPos = $contentObj.__fgOffset - scrollTop / $contentObj.__speed;

        $contentObj.css('transform', "translate(-50%,"+  -yPos + "px)");
        //console.log("translateY("+ yPos+"px)");
      });

      $backgrounds.forEach(function($backgroundObj) {
        var yPos = -((scrollTop - $backgroundObj.__fgOffset) / $backgroundObj.__speed);

        $backgroundObj.css({
          backgroundPosition: '50% ' + yPos + 'px'
        });
      });


    });


    // triggers winodw scroll for refresh
    $fwindow.trigger('scroll');

  };

  parallaxIt();

  var heroSwiper = new Swiper('.hero-swiper', {
      speed:1000,
      autoplay: {
        delay: 7000,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      navigation: {
        nextEl: '.hero-swiper .swiper-button-next',
        prevEl: '.hero-swiper .swiper-button-prev',
      },
  });


  var guestSlide = new Swiper('.guest-slide', {
    slidesPerView: 2,
    spaceBetween: 30,
    grabCursor: true,
    breakpoints: {
      480: {
        slidesPerView: 1
      }
    }
});

  var packageswiper = new Swiper('.pack-swiper', {
      slidesPerView: 4,
      spaceBetween: 0,
       speed:1000,
      loop: $(".pack-swiper .swiper-slide").length>3 ? true: false,
      draggable: true,
      grabCursor: true,
      navigation: {
        nextEl: '.pack-swiper .swiper-button-next',
        prevEl: '.pack-swiper .swiper-button-prev',
      },
       breakpoints: {
   
    575: {
      slidesPerView: 1
    },
    
    767: {
      slidesPerView: 2
    },
    
    991: {
      slidesPerView: 3
    }
  }
    });


var pageSlide = new Swiper('.pageSlide', {
  grabCursor: true,
  speed: 1000,
  watchOverflow: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false
  },
  pagination: {
    el: '.pageSlide .swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.pageSlide .swiper-button-next',
    prevEl: '.pageSlide .swiper-button-prev',
  },
});


// var galleryThumbs = new Swiper('.thumbSlide', {
//   spaceBetween: 5,
//   speed: 1000,
//   slidesPerView: "auto",
//   loop: true,
//   centeredSlides: true,
//   slideToClickedSlide: true,
//   grabCursor: true,
//   navigation: {
//     nextEl: '.thumbswrap .swiper-button-next',
//     prevEl: '.thumbswrap .swiper-button-prev',
//   }
// });

var galleryTop = new Swiper('.bigSlide', {
  spaceBetween: 0,
  speed: 1000,
  loop: true,
  grabCursor: true,
  navigation: {
    nextEl: '.bigSlide .swiper-button-next',
    prevEl: '.bigSlide .swiper-button-prev',
  },
  thumbs: {
    swiper: {
      el: '.thumbSlide',
      spaceBetween: 5,
      speed: 1000,
      slidesPerView: "auto",
      loop: true,
      // centeredSlides: true,
      slideToClickedSlide: false,
      grabCursor: true,
      navigation: {
        nextEl: '.thumbswrap .swiper-button-next',
        prevEl: '.thumbswrap .swiper-button-prev',
      }
     }
  }
});

// galleryTop.params.control = galleryThumbs;
// galleryThumbs.params.control = galleryTop;




var packageSlide = new Swiper('.package-slider', {
  grabCursor: true,
  speed: 1000,
  watchOverflow: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false
  },
  navigation: {
    nextEl: '.package-slider .swiper-button-next',
    prevEl: '.package-slider .swiper-button-prev',
  }
});



$(window).stellar();


/// Tabs
$(".tabs ul li a").on("click", function(){
  var content =  $(this).data("tabs-id");

  $(this).addClass("active").parent().siblings().find("a").removeClass("active");

  $(this).parents(".tabswrapper,.pc-hotels").find('[data-tabs-id="cont-'+content+'"]').fadeIn(500).siblings().hide();
});


function currentNav(){
  if($(".active-nav").length){
   var $currentPage = $(".main-nav .nav > li.active-nav > a").offset().left  - $(".main-nav").offset().left || 0;
 }
  $(".active-line").css({
    left: $currentPage +"px",
    width: $(".main-nav .nav > li.active-nav > a").width() + 16 || 0
  });
}


currentNav();

$(window).on('resize', function(event) {
   currentNav();
});

$(".main-nav > ul > li").hover(function() {
 var $this = $(this).find("a"),
      $pos = $this.offset().left,
      $width = $this.width(),
$activePos = ($pos - $(".main-nav").offset().left);
  $(".active-line").css({
    left: $activePos +"px",
    width: $width + 16
  });
},function(){
  currentNav();
});


   $("a[data-scrollto]").on("click", function(e){
       e.preventDefault();
       var scrollToElm = $(this).data("scrollto");
       if($("#"+scrollToElm).length !== 0){
          var scrollPos = $("#"+scrollToElm).offset().top;
          $("html,body").stop().animate({scrollTop: scrollPos}, 1000);
          $(".hamburger.h-active").trigger("click");
       }
   });


// $(document).on("keyup", function(e){
//    console.log();
//    if(e.keyCode === 27){
//      $(".fancybox-close-small").trigger("click");
//    }
// });

if($(window).width() < 1199){
  $(".main-nav .nav>li a i").on("click", function(e){
    e.stopPropagation();
    $(this).parents("li").siblings().find(".mn-sub").slideUp();
    $(this).parent().next().slideToggle();
    return false;
  });
}



  $(".hamburger").click(function(event) {
    $(this).toggleClass("h-active");
    $("body").toggleClass("menu-active");
  });


  $(".searchtoggle").click(function(event) {
    $("html").toggleClass("search-active");
  });

  $(".search-close").on("click", function(){
    $("html").removeClass("search-active");
  });


  $(".morelist").each(function(){
    var $listlength = $(this).find("li").length;
    console.log($listlength);
    if($listlength > 5){
      $(this).next(".more-btn").show();
    }else{
      $(this).next(".more-btn").hide();
    }
  });

$(".more-btn").on("click", function(){
  if($(this).text() === "More +"){
    $(this).text("Less -");
  } else if($(this).text() === "Less -"){
    $(this).text("More +");
  }
  $(this).prev(".morelist").toggleClass("morelist-active");
});


// share-page popup position

$(".share-page").each(function(){
  var pos = $(this).find(".share-menu").outerWidth() > $(this).find(".share-button").offset().left
  if(pos){
    $(this).addClass("share-left");
  }else{
    $(this).addClass("share-right");
  }
});





}); //document ready end



//accordion

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active_i");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}




//scroll to top

$(document).ready(function(){

  $(window).scroll(function(){
    if ($(this).scrollTop() > 100)
    {
      $('#scroll-top').fadeIn();
    }
    else
    {
      $('#scroll-top').fadeOut();
    }
  });


  $('#scroll-top').click(function(){
    $('html, body').animate({scrollTop : 0},700);
    return false;
  });

});


//active-menu
$(document).ready(function() {

 // Get current page URL
 var url = window.location.href;

 
 // Loop all menu items
 $('.main-nav .nav > li > a').each(function(){

  // select href
  var href = $(this).find('a').attr('href');

  // Check filename
  if(url == href){

   // Select parent class
   var parentClass = $(this).parent('ul').attr('class');
 
   if(parentClass == 'submenu'){
 
    // Add class
    
    $(this).parents('.main-nav .nav > li > a').addClass('activate');
   }else{

    // Add class
    $(this).addClass('activate');
   }
 
  }
 });
});